import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentformComponent } from './paymentform/paymentform.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { PaymentRoutingModule } from './Payment.routing.module';
import { CardNumberMaskDirective } from '@app/shared/directives/card-mask.directive';
import { DxDataGridModule, DxButtonModule, DxPopupModule, DxTemplateModule } from 'devextreme-angular';

@NgModule({
  declarations: [PaymentformComponent,CardNumberMaskDirective],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, PaymentRoutingModule,DxDataGridModule, DxButtonModule, DxPopupModule, DxTemplateModule],
  exports: [PaymentformComponent]
})
export class PaymentModule {}
